module.exports = __webpack_public_path__ + "img/third-right.b9287ae3.png";